<script setup lang="ts">
import AppShell from '@/widgets/app-shell/AppShell.vue';
</script>

<template>
  <AppShell />
</template>
